import { Box, Typography } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { colors } from '@src/styles';
import { cardTitleSX } from '../utils/format';

export interface DailyPoint {
  date: string;
  succeeded: number;
  failed: number;
}

const SERIES = [
  { key: 'succeeded', label: 'Sucesso', color: colors.status.concluded },
  { key: 'failed', label: 'Falha', color: colors.status.rejected },
] as const;

const compactNumber = new Intl.NumberFormat('pt-BR', { notation: 'compact', maximumFractionDigits: 1 });

const formatDay = (date: string): string => {
  const [, month, day] = date.split('-');
  return day && month ? `${day}/${month}` : date;
};

export function DailyExecutionsChart({ data, title = 'Execuções por dia' }: { data: DailyPoint[]; title?: string }) {
  const labels = data.map((d) => formatDay(d.date));
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 1.5 }}>
        <Typography component="h2" sx={{ ...cardTitleSX, flex: 1 }}>
          {title}
        </Typography>
        {SERIES.map((serie) => (
          <Box key={serie.key} sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
            <Box sx={{ width: 8, height: 8, borderRadius: '3px', backgroundColor: serie.color }} />
            <Typography sx={{ fontSize: '12px', color: colors.brand.textSecondary }}>{serie.label}</Typography>
          </Box>
        ))}
      </Box>
      {!data.length ? (
        <Box sx={{ height: 240, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography sx={{ fontSize: '13px', color: colors.brand.textSecondary }}>Sem dados no período.</Typography>
        </Box>
      ) : (
        <BarChart
          height={240}
          hideLegend
          borderRadius={4}
          grid={{ horizontal: true }}
          xAxis={[{ scaleType: 'band', data: labels, categoryGapRatio: 0.45, disableTicks: true }]}
          yAxis={[{ valueFormatter: (value: number) => compactNumber.format(value), disableTicks: true, width: 44 }]}
          series={SERIES.map((serie) => ({
            data: data.map((d) => d[serie.key]),
            label: serie.label,
            stack: 'total',
            color: serie.color,
          }))}
          margin={{ top: 8, right: 8, bottom: 4, left: 0 }}
          sx={{
            '& .MuiChartsGrid-line': { stroke: colors.brand.line, strokeDasharray: '3 4' },
            '& .MuiChartsAxis-line': { stroke: colors.brand.line },
            '& .MuiChartsAxis-left .MuiChartsAxis-line': { display: 'none' },
            '& .MuiChartsAxis-tickLabel': { fill: `${colors.brand.textMuted} !important`, fontSize: '11px !important' },
          }}
        />
      )}
    </Box>
  );
}
